/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Free_Seats_OneInputs */



/**
* | output |
* | --- |
* | "1 free seat – no extra cost" |
*
* @param {Members_Add_Free_Seats_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_free_seats_one = /** @type {((inputs?: Members_Add_Free_Seats_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Free_Seats_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 freier Platz – keine Zusatzkosten")
	return /** @type {LocalizedString} */ ("1 free seat – no extra cost")
});